import { Component, EventEmitter, Input, Output } from "@angular/core";
import { OutboundCasesTO, StatusTO } from "src/app/wings-mobile/models/dispatchingAndInvoicing/dispatch-and-invoice-response.model";
import { RouteCurrent } from "../dispatching-invoicing.component";
import { NgIf, DecimalPipe } from "@angular/common";
import { ButtonDirective } from "primeng/button";
import { CaseInfoEditionComponent } from "./case-info-edition/case-info-edition.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    'selector': 'case-info-display',
    'templateUrl': './case-info-display.component.html',
    'styleUrls': ['./case-info-display.component.scss'],
    imports: [NgIf, ButtonDirective, CaseInfoEditionComponent, DecimalPipe, TranslatePipe]
})
export class CaseInfoDisplayComponent{
  LOADING_CASE_STATUS = 10;

  @Input() case : OutboundCasesTO;
  @Input() caseStatus : StatusTO;
  @Input() routeCurrent : RouteCurrent;
  @Input() exportF: string;

  @Output() successSaveCaseInfo = new EventEmitter();
  @Output() editionModalClose = new EventEmitter();
  @Output() focusBackCase = new EventEmitter();

  isModalOpen : boolean = false;

  openModal(){
    this.isModalOpen = true;
    this.routeCurrent.isVisibleWeight = false;
  }

  closeModal(){
    this.isModalOpen = false;
    this.routeCurrent.isVisibleWeight = true;
    this.focusBackCaseEvent();
  }

  focusBackCaseEvent(){
    this.focusBackCase.emit();
  }

  onCaseInfoSave(){
    this.successSaveCaseInfo.emit(this.case.bkCaseR);
  }
}

